module.exports = __webpack_public_path__ + "static/media/ums.91947a4f.svg";